import { writable, type Readable } from 'svelte/store'

/** Tagged-union route. Add cases as new screens land in later phases. */
export type Route =
  | { name: 'list' }
  | { name: 'city'; planId: number }
  | { name: 'unknown'; hash: string }

function parse(hash: string): Route {
  const clean = hash.replace(/^#?\/*/, '')
  if (clean === '' || clean === '/') return { name: 'list' }
  const cityMatch = clean.match(/^city\/(\d+)$/)
  if (cityMatch) return { name: 'city', planId: Number(cityMatch[1]) }
  return { name: 'unknown', hash }
}

const route = writable<Route>(parse(typeof location !== 'undefined' ? location.hash : ''))

if (typeof window !== 'undefined') {
  window.addEventListener('hashchange', () => {
    route.set(parse(location.hash))
  })
}

export const currentRoute: Readable<Route> = route

export function navigate(to: Route): void {
  if (typeof window === 'undefined') return
  const hash = serialize(to)
  if (location.hash === hash) {
    route.set(to)
    return
  }
  location.hash = hash
}

export function serialize(to: Route): string {
  switch (to.name) {
    case 'list':
      return '#/'
    case 'city':
      return `#/city/${to.planId}`
    case 'unknown':
      return to.hash || '#/'
  }
}
